//Please add the language resource
const printShipOrder = {

  msg:{
  }
};
export default printShipOrder



// WEBPACK FOOTER //
// ./src/page/order/orderPickupNotice/lang/orderPickupNotice.en.js